// Insertion CRM
function insertIntoCRM(event) {
	var data = {};
	var insert = true;

	try {
		event.detail.inputs.forEach(function (input) {
			// Présence d'une PJ dans le formulaire => formulaire de recrutement
			if (typeof (input.value) != 'string') {
				insert = false;
				return false;
			}

			if (input.name.slice(-2) == '[]') {
				if (data[input.name.slice(0, -2)] == undefined) {
					data[input.name.slice(0, -2)] = [];
				}
				data[input.name.slice(0, -2)].push(input.value);
			} else {
				data[input.name] = input.value;
			}

		});
		data.language = mcubeArgs.currentLang;
		data.token = 'mcube';
		if (insert) {
			$.ajax({
				method: 'POST',
				url: '/insert-crm.php',
				data: data
			});
		}
	} catch (e) {
		data.error = "Error - insertIntoCRM - " + e.message;
		$.ajax({
			method: 'POST',
			url: '/wp-json/wellness-front/v1/error-crm',
			data: data
		});
	}

}

function initForms() {
	$body = $('body');
	$formNewsletter = $('.form-newsletter');
	$formNewsletterBlog = $('.form-newsletter-blog');
	$formOverlay = $('.form-block .form-overlay');
	$formSuccess = $('.form-block .form-success');
	$formLoader = $('.form-block .form-loader');
	$formSuccessLanding = $('.landing-form .form-success');
	$formSuccessInPage = $('.in-page-form .form-success');
	$formLoaderLanding = $('.landing-form .form-loader');
	$formLoaderInPage = $('.in-page-form .form-loader');
	$formBlock = $('.form-block');
	$formReset = $('.form-content #resetForm');
	$formResetInPage = $('.in-page-form #resetFormInPage');
	$formResetLanding = $('.landing-form #resetFormLanding');
	$formClose = $('.form-content .form-close');


	// Show new spinner on submit
	$('.form-newsletter .wpcf7-submit').on('click', function () {
		$formNewsletter.addClass('loading');
	});

	$('.form-newsletter-blog .wpcf7-submit').on('click', function () {
		$formNewsletterBlog.addClass('loading');
	});

	// Show new spinner on submit
	$('.form-content .wpcf7-submit').on('click', function () {
		$formLoader.addClass('show');
	});

	// Landing
	$('.landing-form .wpcf7-submit').on('click', function () {
		$formLoaderLanding.addClass('show');
	});

	// In Page
	$('.in-page-form .wpcf7-submit').on('click', function () {
		$formLoaderInPage.addClass('show');
	});

	// Hide new spinner on result
	$('.form-newsletter  div.wpcf7').on('wpcf7invalid wpcf7spam wpcf7mailfailed', function () {
		$formNewsletter.removeClass('loading');
	});

	$('.form-newsletter-blog  div.wpcf7').on('wpcf7invalid wpcf7spam wpcf7mailfailed', function () {
		$formNewsletterBlog.removeClass('loading');
	});

	// Hide new spinner on result
	$('.form-content div.wpcf7').on('wpcf7invalid wpcf7spam wpcf7mailfailed', function () {
		$formLoader.removeClass('show');
	});

	// Hide new spinner on result Landing
	$('.landing-form div.wpcf7').on('wpcf7invalid wpcf7spam wpcf7mailfailed', function () {
		$formLoaderLanding.removeClass('show');
	});

	// Hide new spinner on result in page
	$('.in-page-form div.wpcf7').on('wpcf7invalid wpcf7spam wpcf7mailfailed', function () {
		$formLoaderInPage.removeClass('show');
	});

	$('.form-newsletter div.wpcf7').on('wpcf7mailsent', function (event) {
		if (window.location.host.indexOf("wellness-sportclub.fr") > -1) {
			insertIntoCRM(event);
		}

		$formNewsletter.removeClass('loading');
		$formNewsletter.addClass('success');

		setTimeout(function () {
			$body.removeClass('noscroll');
			$formNewsletter.removeClass('success');
		}, 14000);
	});

	$('.form-newsletter-blog div.wpcf7').on('wpcf7mailsent', function (event) {
		if (window.location.host.indexOf("wellness-sportclub.fr") > -1) {
			insertIntoCRM(event);
		}

		$formNewsletterBlog.removeClass('loading');
		$formNewsletterBlog.addClass('success');

		setTimeout(function () {
			$body.removeClass('noscroll');
			$formNewsletterBlog.removeClass('success');
		}, 14000);
	});

	$('.form-content div.wpcf7').on('wpcf7mailsent', function (event) {
		insertIntoCRM(event);

		$formLoader.removeClass('show');
		$formSuccess.addClass('show');

		setTimeout(function () {
			$body.removeClass('noscroll');
			$body.removeClass('modalmode');

			var $heroSlider = $('#hero_slider');

			if ($heroSlider.length && isTouch) {
				$heroSlider.slick('slickNext');
				$body.removeClass('header-is-hidden');
				$body.addClass('header-is-visible');
			}

			$formBlock.removeClass('show');
			$formSuccess.removeClass('show');
			$formReset.click();

			var $post_type = $('input[name="submission_post_type"]').val();
			var $current_club = "";

			if ($post_type === 'landing') {
				$current_club = $('.landing-form').data('current-club');

				if ($current_club !== undefined) {
					$('[name="club-list"]').val($current_club).change();
					$('[name="club-list"]').closest('.form__container').addClass('hidden').addClass('filled');
				} else {
					$('[name="club-list"]').closest('.form__container').removeClass('filled');
				}
			}
		}, 14000);
	});

	// Landing
	$('.landing-form div.wpcf7').on('wpcf7mailsent', function (event) {
		insertIntoCRM(event);

		$formLoaderLanding.removeClass('show');
		$formSuccessLanding.addClass('show');

		setTimeout(function () {
			$formSuccessLanding.removeClass('show');
			$formResetLanding.click();

			var $post_type = $('input[name="submission_post_type"]').val();
			var $current_club = "";

			$current_club = $('.landing-form').data('current-club');

			if ($current_club !== undefined) {
				$('.landing-form [name="club-list"]').val($current_club).change();
				$('.landing-form [name="club-list"]').closest('.form__container').addClass('hidden').addClass('filled');
			} else {
				$('.landing-form [name="club-list"]').closest('.form__container').removeClass('filled');
			}
		}, 14000);
	});

	// In Page
	$('.in-page-form div.wpcf7').on('wpcf7mailsent', function (event) {
		insertIntoCRM(event);

		$formLoaderInPage.removeClass('show');
		$formSuccessInPage.addClass('show');

		setTimeout(function () {
			$formSuccessInPage.removeClass('show');
			$formResetInPage.click();

			$single_club = $('.in-page-form').data('single-club');
			if ($single_club !== undefined) {
				$('.in-page-form [name="club-list"]').val($single_club).change();
				$('.in-page-form [name="club-list"]').closest('.form__container').addClass('hidden').addClass('filled');
			} else {
				$('.in-page-form [name="club-list"]').closest('.form__container').removeClass('filled');
			}
		}, 14000);
	});

	$formReset.on('click', function () {
		$('.form-content .form__container').removeClass('active, filled');
		$('.form-content .wpcf7-response-output').removeClass('wpcf7-mail-sent-ok').addClass('wpcf7-display-none').css('display', 'none');
	});

	$formResetLanding.on('click', function () {
		$('.landing-form .form__container:not(.form__container--select)').removeClass('active, filled');
		$('.landing-form .wpcf7-response-output').removeClass('wpcf7-mail-sent-ok').addClass('wpcf7-display-none').css('display', 'none');
	});

	$formResetInPage.on('click', function () {
		$('.in-page-form .form__container:not(.form__container--select)').removeClass('active, filled');
		$('.in-page-form .wpcf7-response-output').removeClass('wpcf7-mail-sent-ok').addClass('wpcf7-display-none').css('display', 'none');
	});

	$formOverlay.on('click', function () {
		$body.removeClass('noscroll');
		$body.removeClass('modalmode');
		var $heroSlider = $('#hero_slider');
		if ($heroSlider.length && isTouch) {
			$heroSlider.slick('slickNext');
			$body.removeClass('header-is-hidden');
			$body.addClass('header-is-visible');
		}
		$formBlock.removeClass('show');
		$formSuccess.removeClass('show');

	});

	$formClose.on('click', function () {
		$body.removeClass('noscroll');
		$body.removeClass('modalmode');
		var $heroSlider = $('#hero_slider');
		if ($heroSlider.length && isTouch) {
			$heroSlider.slick('slickNext');
			$body.removeClass('header-is-hidden');
			$body.addClass('header-is-visible');
		}
		$formBlock.removeClass('show');
		$formSuccess.removeClass('show');
	});

	$('.form__field input, .form__textarea textarea, .form__select select').each(function () {
		$(this).on('focus', function () {
			$(this).closest('.form__container').addClass('active');
		}).on('blur', function () {
			$(this).closest('.form__container').removeClass('active');

			if ($(this).val() === "") {
				$(this).closest('.form__container').removeClass('filled');
			} else {
				$(this).closest('.form__container').addClass('filled');
			}
		});
	});

	var $post_type = $('input[name="submission_post_type"]').val();
	var $current_club = "";

	if ($post_type === 'landing' || $post_type === 'landing-club' || $post_type === 'landing-standalone' || $post_type === 'activity') {
		$current_club = $('.landing-form').data('current-club');
		$single_club = $('.landing-form').data('single-club');

		$clubs_selection = $('.landing-form').data('clubs-selection');
		$form_crm_name = $('.landing-form').data('crm-name');

		// console.log($current_club, $single_club, $clubs_selection, $form_crm_name);

		if ($post_type === 'activity' && $form_crm_name !== undefined) {
			$('.landing-form input[name="formname"]').val($form_crm_name);
		}

		if ($clubs_selection !== undefined) {
			$club_array = $clubs_selection.split(';');
			// remove options from select $('[name="club-list"]') that are not in $club_array and not the first one
			$('.landing-form [name="club-list"] option').each(function () {
				if ($club_array.indexOf($(this).val()) === -1 && $(this).val() !== "") {
					$(this).remove();
				}
			});

		} else if ($single_club !== undefined) {
			// Un seul club dans tout le site. On le sélectionne et on cache le select
			setTimeout(() => {
				$('[name="club-list"]').val($single_club).change();
			}, 2000);
			$('[name="club-list"]').closest('.form__container').addClass('hidden').addClass('filled');
		} else if ($current_club !== undefined) {
			// Un seul club sélectionné. On le sélectionne et on cache le select
			setTimeout(() => {
				$('[name="club-list"]').val($current_club).change();
			}, 2000);
			$('[name="club-list"]').closest('.form__container').addClass('hidden').addClass('filled');
		} else {
			$('[name="club-list"]').closest('.form__container').removeClass('filled');
		}
	}

	if ($('.in-page-form').data('single-club') !== undefined) {
		setTimeout(() => {
			$('[name="club-list"]').val($('.in-page-form').data('single-club')).change();
		}, 2000);
		$('[name="club-list"]').closest('.form__container').addClass('hidden').addClass('filled');
	}

	if ($post_type === 'page' && $('.in-page-form').data('crm') != undefined) {
		if ($('.in-page-form').data('activity-field') == true) {
			$('.in-page-form')
				.find('select#activity-list')
				.closest('.form__container')
				.removeClass('hidden');
		} else {
			$('.in-page-form')
				.find('select#activity-list')
				.closest('.form__container')
				.addClass('hidden');
		}

		$('.in-page-form input[name="formname"]').val($('.in-page-form').data('crm'));

	}

	if ($('body').hasClass('single-job')) {
		var city = $('.in-page-form').data('city');
		$('input[name="job_city"]').val(city);
	}

	$('button#submit').on('click', function () {
		$(this).addClass('inactive');

		setTimeout(function () {
			$('button#submit').removeClass('inactive');
		}, 1000);
	});

	$('[name="club-list"]').on('change', function (e) {
		if (window.isAppointmentOrCallbackHidden) {
			return;
		}
		var optionSelected = $("option:selected", this);
		if (optionSelected.data("no-appointment") === true) {
			hideAppointmentOrCallback(this.closest(".wpcf7"));
		} else {

			const form = this.closest(".wpcf7");
			const appointmentInput = form.querySelector(`input[name="appointment_or_call_back"][value="appointment"]`);
			if (appointmentInput) {
				appointmentInput.checked = true;
			}

			const appointmentSelector = form.querySelector(`.appointment-selector`);
			if (appointmentInput) {
				appointmentSelector.classList.remove("d-none");
				const dateSelector = appointmentSelector.querySelector(".date-selector");
				$(dateSelector).slick("refresh");
			}

			const callbackInput = form.querySelector(`input[name="appointment_or_call_back"][value="callback"]`);
			if (callbackInput) {
				callbackInput.checked = false;
			}

			$(this).closest(".wpcf7").find(".appointment-selector-item").removeClass("hidden");
		}
	});
}

function initFormGeneration() {
	$('.display-contact-form').on('click', function (e) {

		e.preventDefault();
		e.stopPropagation();

		var $title = $(this).data('form-title');
		var $subtitle = $(this).data('form-subtitle');
		var $display_activity_field = $(this).data('activity-field');
		var $hide_hour_row = $(this).data('hide-hour-row');
		var $hide_message = $(this).data('hide-message');
		var $hide_appointment_or_callback = $(this).data('hide-appointment-or-callback');
		window.isAppointmentOrCallbackHidden = $hide_appointment_or_callback;
		var $crm_name = $(this).data('crm');
		var $legal = $(this).data('legal');
		var $single_club = $('.form-content').data('single-club');

		$('body').addClass('noscroll');
		$('body').addClass('modalmode');

		$('.form-block .form__legal > div').addClass('hidden');
		$('.form-block').addClass('show');
		$('.form-content').find('.form__title').empty().append($title);
		$('.form-content').find('.form__subtitle').empty().append($subtitle);
		$('#activity-list').val('').closest('.form__container').removeClass('filled');
		$('.form-content input[name="formname"]').val('');

		if ($display_activity_field === true) {
			$('.form-content')
				.find('select#activity-list')
				.closest('.form__container')
				.removeClass('hidden');
		} else {
			$('.form-content')
				.find('select#activity-list')
				.closest('.form__container')
				.addClass('hidden');
		}

		if ($hide_appointment_or_callback === true) {
			hideAppointmentOrCallback($('.form-content')[0]);
		} else {
			$('.form-content')
				.find('.appointment-selector-item')
				.removeClass('hidden');

		}

		if ($hide_hour_row == true) {
			$('.form-content')
				.find('.hour-row')
				.addClass('hidden');
		} else {
			$('.form-content')
				.find('.hour-row')
				.removeClass('hidden');
		}

		if ($hide_message == true) {
			$('.form-content')
				.find('.form__container--textarea')
				.addClass('hidden');
		} else {
			$('.form-content')
				.find('.form__container--textarea')
				.removeClass('hidden');
		}

		if (!$legal || $legal === 'none') {
			$('.form__legal .none').removeClass('hidden');
		} else {
			$('.form__legal').find('.' + $legal).removeClass('hidden');
		}

		// Insertion du nom CRM dans le champ hidden
		if ($crm_name != undefined) {
			$('.form-content input[name="formname"]').val($crm_name);
		}

		/* Pré-selection du club courant dans le formulaire
		   si l'on se trouve sur une page de club ou de news
		   d'un club ou une landing spécifique à un club
		   On vérifie aussi en premier lieu s'il d'agit d'un
		   site avec un unqiue club, auquel cas le champs est
		   masqué
		*/
		var $current_club = "";
		var $current_activity = "";
		var $post_type = $('input[name="submission_post_type"]').val();

		var $club_select = $('.form-content').find('[name="club-list"]');
		if ($single_club) {
			$club_select.val($single_club).change();
			$club_select.closest('.form__container').addClass('filled').addClass('hidden');

		} else {
			if ($post_type === 'club' || $post_type === "news") {
				$current_club = $('.form-content').data('current-club');
				if ($current_club !== undefined) {
					$('[name="club-list"]').val($current_club).change();
					$('[name="club-list"]').closest('.form__container').addClass('filled');
				}
			}
		}

		var optionSelected = $("option:selected", $club_select);
		if (optionSelected.data("no-appointment") === true) {
			hideAppointmentOrCallback($('.form-content').find(".wpcf7")[0]);
		}

		/* Pré-selection de l’activité dans le formulaire
		   si l'on se trouve sur une page d'activité
		*/
		if ($post_type === 'activity') {
			$current_activity = $('.form-content').data('current-activity');

			if ($current_activity !== undefined) {
				$('#activity-list').val($current_activity);
				$('#activity-list').closest('.form__container').addClass('filled');
			}

            $clubs_selection = $('.associated-clubs').attr('data-clubs-selection');

            if ($clubs_selection !== undefined) {

                $club_array = $clubs_selection.split(';');
                console.log($club_array);
                // remove options from select $('[name="club-list"]') that are not in $club_array and not the first one
                $('.form-content [name="club-list"] option').each(function () {
                    if ($club_array.indexOf($(this).val()) === -1 && $(this).val() !== "") {
                        $(this).remove();
                    }
                });

            }
		}

		if ($post_type === 'landing') {

			$current_club = $('.form-content').data('current-club');
			$club_select = $('.form-content [name="club-list"]');

			if ($current_club !== undefined) {
				$club_select.val($current_club).change();
				$club_select.closest('.form__container').addClass('hidden').addClass('filled');
			} else {
				$club_select.closest('.form__container').removeClass('filled');
			}
		}
		return false;
	});
}

function hideAppointmentOrCallback(form) {
	form.querySelectorAll('.appointment-selector-item').forEach(item => {
		item.classList.add("hidden");
	});

	const dateInput = form.querySelector(`input[name="appointment_date"]`);
	if (dateInput) {
		dateInput.value = "";
		dateInput.setAttribute("value", "");
	}

	const hourInput = form.querySelector(`input[name="appointment_hour"]`);
	if (hourInput) {
		hourInput.value = "";
		hourInput.setAttribute("value", "");
	}

	const isoDateInput = form.querySelector(`input[name="appointment_date_iso"]`);
	if (isoDateInput) {
		isoDateInput.value = "";
		isoDateInput.setAttribute("value", "");
	}

	const appointmentInput = form.querySelector(`input[name="appointment_or_call_back"][value="appointment"]`);
	if (appointmentInput) {
		appointmentInput.checked = false;
	}

	const callbackInput = form.querySelector(`input[name="appointment_or_call_back"][value="callback"]`);
	if (callbackInput) {
		callbackInput.checked = true;
	}

	const activeDate = form.querySelector(".date-selector .date.active");
	if (activeDate) {
		activeDate.classList.remove("active");
	}

	const activeHour = form.querySelector(".hour-selector .hour.active");
	if (activeHour) {
		activeHour.classList.remove("active");
	}

	const appointmentSelector = form.querySelector(".appointment-selector");
	if (appointmentSelector) {
		appointmentSelector.classList.add("active");
	}
}

function initPhoneInputs() {
	this.telInputEls = document.querySelectorAll('.wpcf7 input[type="tel"]');

	if (!this.telInputEls) {
		return;
	}

	this.telInputEls.forEach((telInputEl) => {
		const locale = mcubeArgs.currentLang;
		const isCH = document.body.classList.contains("is-ch");

		telInputEl.iti = intlTelInput(telInputEl, {
			utilsScript: `${mcubeArgs.themeLink}/lib/intlTelInputUtils.js`,
			loadUtils: () => import(`${mcubeArgs.themeLink}/lib/intlTelInput.utils.js`),
			showSelectedDialCode: true,
			showFlags: true,
			initialCountry: isCH ? 'ch' : 'fr',
			countryOrder:  isCH ? ["ch", "fr"] : ["fr", "ch"],
			useFullscreenPopup: false,
			nationalMode: false,
			autoPlaceholder: false,
			hiddenInput: () => ({phone: "formatted-phone"}),
			i18n: {
				searchPlaceholder: locale === 'en' ? 'Search' : 'Recherche',
				af: mcubeArgs.currentLang === "en" ? "Afghanistan" : "Afghanistan",
				al: mcubeArgs.currentLang === "en" ? "Albania" : "Albanie",
				dz: mcubeArgs.currentLang === "en" ? "Algeria" : "Algérie",
				as: mcubeArgs.currentLang === "en" ? "American Samoa" : "Samoa américaines",
				ad: mcubeArgs.currentLang === "en" ? "Andorra" : "Andorre",
				ao: mcubeArgs.currentLang === "en" ? "Angola" : "Angola",
				ai: mcubeArgs.currentLang === "en" ? "Anguilla" : "Anguilla",
				ag: mcubeArgs.currentLang === "en" ? "Antigua & Barbuda" : "Antigua-et-Barbuda",
				ar: mcubeArgs.currentLang === "en" ? "Argentina" : "Argentine",
				am: mcubeArgs.currentLang === "en" ? "Armenia" : "Arménie",
				aw: mcubeArgs.currentLang === "en" ? "Aruba" : "Aruba",
				ac: mcubeArgs.currentLang === "en" ? "Ascension Island" : "Île de l'Ascension",
				au: mcubeArgs.currentLang === "en" ? "Australia" : "Australie",
				at: mcubeArgs.currentLang === "en" ? "Austria" : "Autriche",
				az: mcubeArgs.currentLang === "en" ? "Azerbaijan" : "Azerbaïdjan",
				bs: mcubeArgs.currentLang === "en" ? "Bahamas" : "Bahamas",
				bh: mcubeArgs.currentLang === "en" ? "Bahrain" : "Bahreïn",
				bd: mcubeArgs.currentLang === "en" ? "Bangladesh" : "Bangladesh",
				bb: mcubeArgs.currentLang === "en" ? "Barbados" : "Barbade",
				by: mcubeArgs.currentLang === "en" ? "Belarus" : "Biélorussie",
				be: mcubeArgs.currentLang === "en" ? "Belgium" : "Belgique",
				bz: mcubeArgs.currentLang === "en" ? "Belize" : "Belize",
				bj: mcubeArgs.currentLang === "en" ? "Benin" : "Benin",
				bm: mcubeArgs.currentLang === "en" ? "Bermuda" : "Bermudes",
				bt: mcubeArgs.currentLang === "en" ? "Bhutan" : "Bhoutan",
				bo: mcubeArgs.currentLang === "en" ? "Bolivia" : "Bolivie",
				ba: mcubeArgs.currentLang === "en" ? "Bosnia & Herzegovina" : "Bosnie-Herzégovine",
				bw: mcubeArgs.currentLang === "en" ? "Botswana" : "Botswana",
				br: mcubeArgs.currentLang === "en" ? "Brazil" : "Brésil",
				io: mcubeArgs.currentLang === "en" ? "British Indian Ocean Territory" : "Territoire britannique de l'océan Indien",
				vg: mcubeArgs.currentLang === "en" ? "British Virgin Islands" : "Îles Vierges britanniques",
				bn: mcubeArgs.currentLang === "en" ? "Brunei" : "Brunei",
				bg: mcubeArgs.currentLang === "en" ? "Bulgaria" : "Bulgarie",
				bf: mcubeArgs.currentLang === "en" ? "Burkina Faso" : "Burkina Faso",
				bi: mcubeArgs.currentLang === "en" ? "Burundi" : "Burundi",
				kh: mcubeArgs.currentLang === "en" ? "Cambodia" : "Cambodge",
				cm: mcubeArgs.currentLang === "en" ? "Cameroon" : "Cameroun",
				ca: mcubeArgs.currentLang === "en" ? "Canada" : "Canada",
				cv: mcubeArgs.currentLang === "en" ? "Cape Verde" : "Cap-Vert",
				bq: mcubeArgs.currentLang === "en" ? "Caribbean Netherlands" : "Antilles néerlandaises",
				ky: mcubeArgs.currentLang === "en" ? "Cayman Islands" : "Îles Caïmans",
				cf: mcubeArgs.currentLang === "en" ? "Central African Republic" : "République centrafricaine",
				td: mcubeArgs.currentLang === "en" ? "Chad" : "Tchad",
				cl: mcubeArgs.currentLang === "en" ? "Chile" : "Chili",
				cn: mcubeArgs.currentLang === "en" ? "China" : "Chine",
				cx: mcubeArgs.currentLang === "en" ? "Christmas Island" : "île de Noël",
				cc: mcubeArgs.currentLang === "en" ? "Cocos (Keeling) Islands" : "îles Cocos",
				co: mcubeArgs.currentLang === "en" ? "Colombia" : "Colombie",
				km: mcubeArgs.currentLang === "en" ? "Comoros" : "Comores",
				cg: mcubeArgs.currentLang === "en" ? "Congo - Brazzaville" : "République du Congo",
				cd: mcubeArgs.currentLang === "en" ? "Congo - Kinshasa" : "République démocratique du Congo",
				ck: mcubeArgs.currentLang === "en" ? "Cook Islands" : "Îles Cook",
				cr: mcubeArgs.currentLang === "en" ? "Costa Rica" : "Costa Rica",
				ci: mcubeArgs.currentLang === "en" ? "Ivory Coast" : "Côte d'Ivoire",
				hr: mcubeArgs.currentLang === "en" ? "Croatia" : "Croatie",
				cu: mcubeArgs.currentLang === "en" ? "Cuba" : "Cuba",
				cw: mcubeArgs.currentLang === "en" ? "Curaçao" : "Curaçao",
				cy: mcubeArgs.currentLang === "en" ? "Cyprus" : "Chypre",
				cz: mcubeArgs.currentLang === "en" ? "Czech Republic" : "République tchèque",
				dk: mcubeArgs.currentLang === "en" ? "Denmark" : "Danemark",
				dj: mcubeArgs.currentLang === "en" ? "Djibouti" : "Djibouti",
				dm: mcubeArgs.currentLang === "en" ? "Dominica" : "Dominique",
				do: mcubeArgs.currentLang === "en" ? "Dominican Republic" : "République dominicaine",
				ec: mcubeArgs.currentLang === "en" ? "Ecuador" : "Équateur",
				eg: mcubeArgs.currentLang === "en" ? "Egypt" : "Égypte",
				sv: mcubeArgs.currentLang === "en" ? "El Salvador" : "Salvador",
				gq: mcubeArgs.currentLang === "en" ? "Equatorial Guinea" : "Guinée équatoriale",
				er: mcubeArgs.currentLang === "en" ? "Eritrea" : "Érythrée",
				ee: mcubeArgs.currentLang === "en" ? "Estonia" : "Estonie",
				sz: mcubeArgs.currentLang === "en" ? "Eswatini" : "Swaziland",
				et: mcubeArgs.currentLang === "en" ? "Ethiopia" : "Ethiopie",
				fk: mcubeArgs.currentLang === "en" ? "Falkland Islands" : "Îles Malouines",
				fo: mcubeArgs.currentLang === "en" ? "Faroe Islands" : "Îles Féroé",
				fj: mcubeArgs.currentLang === "en" ? "Fiji" : "Fidji",
				fi: mcubeArgs.currentLang === "en" ? "Finland" : "Finland",
				fr: mcubeArgs.currentLang === "en" ? "France" : "France",
				gf: mcubeArgs.currentLang === "en" ? "French Guiana" : "Guyane française",
				pf: mcubeArgs.currentLang === "en" ? "French Polynesia" : "Polynésie française",
				ga: mcubeArgs.currentLang === "en" ? "Gabon" : "Gabon",
				gm: mcubeArgs.currentLang === "en" ? "Gambia" : "Gambie",
				ge: mcubeArgs.currentLang === "en" ? "Georgia" : "Georgie",
				de: mcubeArgs.currentLang === "en" ? "Germany" : "Allemagne",
				gh: mcubeArgs.currentLang === "en" ? "Ghana" : "Ghana",
				gi: mcubeArgs.currentLang === "en" ? "Gibraltar" : "Gibraltar",
				gr: mcubeArgs.currentLang === "en" ? "Greece" : "Grèce",
				gl: mcubeArgs.currentLang === "en" ? "Greenland" : "Groenland",
				gd: mcubeArgs.currentLang === "en" ? "Grenada" : "Grenada",
				gp: mcubeArgs.currentLang === "en" ? "Guadeloupe" : "Guadeloupe",
				gu: mcubeArgs.currentLang === "en" ? "Guam" : "Guam",
				gt: mcubeArgs.currentLang === "en" ? "Guatemala" : "Guatemala",
				gg: mcubeArgs.currentLang === "en" ? "Guernsey" : "Guernsey",
				gn: mcubeArgs.currentLang === "en" ? "Guinea" : "Guinée",
				gw: mcubeArgs.currentLang === "en" ? "Guinea-Bissau" : "Guinée‑Bissau",
				gy: mcubeArgs.currentLang === "en" ? "Guyana" : "Guyana",
				ht: mcubeArgs.currentLang === "en" ? "Haiti" : "Haiti",
				hn: mcubeArgs.currentLang === "en" ? "Honduras" : "Honduras",
				hk: mcubeArgs.currentLang === "en" ? "Hong Kong" : "Hong Kong",
				hu: mcubeArgs.currentLang === "en" ? "Hungary" : "Hongrie",
				is: mcubeArgs.currentLang === "en" ? "Iceland" : "Islande",
				in: mcubeArgs.currentLang === "en" ? "India" : "Inde",
				id: mcubeArgs.currentLang === "en" ? "Indonesia" : "Indonésie",
				ir: mcubeArgs.currentLang === "en" ? "Iran" : "Iran",
				iq: mcubeArgs.currentLang === "en" ? "Iraq" : "Iraq",
				ie: mcubeArgs.currentLang === "en" ? "Ireland" : "Ireland",
				im: mcubeArgs.currentLang === "en" ? "Isle of Man" : "Île de Man",
				il: mcubeArgs.currentLang === "en" ? "Israel" : "Israel",
				it: mcubeArgs.currentLang === "en" ? "Italy" : "Italie",
				jm: mcubeArgs.currentLang === "en" ? "Jamaica" : "Jamaïque",
				jp: mcubeArgs.currentLang === "en" ? "Japan" : "Japan",
				je: mcubeArgs.currentLang === "en" ? "Jersey" : "Jersey",
				jo: mcubeArgs.currentLang === "en" ? "Jordan" : "Jordanie",
				kz: mcubeArgs.currentLang === "en" ? "Kazakhstan" : "Kazakhstan",
				ke: mcubeArgs.currentLang === "en" ? "Kenya" : "Kenya",
				ki: mcubeArgs.currentLang === "en" ? "Kiribati" : "Kiribati",
				xk: mcubeArgs.currentLang === "en" ? "Kosovo" : "Kosovo",
				kw: mcubeArgs.currentLang === "en" ? "Kuwait" : "Koweit",
				kg: mcubeArgs.currentLang === "en" ? "Kyrgyzstan" : "Kirghizistan",
				la: mcubeArgs.currentLang === "en" ? "Laos" : "Laos",
				lv: mcubeArgs.currentLang === "en" ? "Latvia" : "Lettonie",
				lb: mcubeArgs.currentLang === "en" ? "Lebanon" : "Liban",
				ls: mcubeArgs.currentLang === "en" ? "Lesotho" : "Lesotho",
				lr: mcubeArgs.currentLang === "en" ? "Liberia" : "Libéria",
				ly: mcubeArgs.currentLang === "en" ? "Libya" : "Libie",
				li: mcubeArgs.currentLang === "en" ? "Liechtenstein" : "Liechtenstein",
				lt: mcubeArgs.currentLang === "en" ? "Lithuania" : "Lituanie",
				lu: mcubeArgs.currentLang === "en" ? "Luxembourg" : "Luxembourg",
				mo: mcubeArgs.currentLang === "en" ? "Macau" : "Macau",
				mg: mcubeArgs.currentLang === "en" ? "Madagascar" : "Madagascar",
				mw: mcubeArgs.currentLang === "en" ? "Malawi" : "Malawi",
				my: mcubeArgs.currentLang === "en" ? "Malaysia" : "Malaisie",
				mv: mcubeArgs.currentLang === "en" ? "Maldives" : "Maldives",
				ml: mcubeArgs.currentLang === "en" ? "Mali" : "Mali",
				mt: mcubeArgs.currentLang === "en" ? "Malta" : "Malte",
				mh: mcubeArgs.currentLang === "en" ? "Marshall Islands" : "Iles Marshall",
				mq: mcubeArgs.currentLang === "en" ? "Martinique" : "Martinique",
				mr: mcubeArgs.currentLang === "en" ? "Mauritania" : "Mauritanie",
				mu: mcubeArgs.currentLang === "en" ? "Mauritius" : "Maurice",
				yt: mcubeArgs.currentLang === "en" ? "Mayotte" : "Mayotte",
				mx: mcubeArgs.currentLang === "en" ? "Mexico" : "Mexique",
				fm: mcubeArgs.currentLang === "en" ? "Micronesia" : "Micronésie",
				md: mcubeArgs.currentLang === "en" ? "Moldova" : "Moldavie",
				mc: mcubeArgs.currentLang === "en" ? "Monaco" : "Monaco",
				mn: mcubeArgs.currentLang === "en" ? "Mongolia" : "Mongolie",
				me: mcubeArgs.currentLang === "en" ? "Montenegro" : "Montenegro",
				ms: mcubeArgs.currentLang === "en" ? "Montserrat" : "Montserrat",
				ma: mcubeArgs.currentLang === "en" ? "Morocco" : "Maroc",
				mz: mcubeArgs.currentLang === "en" ? "Mozambique" : "Mozambique",
				mm: mcubeArgs.currentLang === "en" ? "Myanmar (Burma)" : "Birmanie",
				na: mcubeArgs.currentLang === "en" ? "Namibia" : "Namibie",
				nr: mcubeArgs.currentLang === "en" ? "Nauru" : "Nauru",
				np: mcubeArgs.currentLang === "en" ? "Nepal" : "Nepal",
				nl: mcubeArgs.currentLang === "en" ? "Netherlands" : "Pays-Bas",
				nc: mcubeArgs.currentLang === "en" ? "New Caledonia" : "Nouvelle-Calédonie",
				nz: mcubeArgs.currentLang === "en" ? "New Zealand" : "Nouvelle-Zélande",
				ni: mcubeArgs.currentLang === "en" ? "Nicaragua" : "Nicaragua",
				ne: mcubeArgs.currentLang === "en" ? "Niger" : "Niger",
				ng: mcubeArgs.currentLang === "en" ? "Nigeria" : "Nigéria",
				nu: mcubeArgs.currentLang === "en" ? "Niue" : "Niué",
				nf: mcubeArgs.currentLang === "en" ? "Norfolk Island" : "ile de Norfolk",
				kp: mcubeArgs.currentLang === "en" ? "North Korea" : "Corée du Nord",
				mk: mcubeArgs.currentLang === "en" ? "North Macedonia" : "Macédoine du Nord",
				mp: mcubeArgs.currentLang === "en" ? "Northern Mariana Islands" : "Îles Mariannes du Nord",
				no: mcubeArgs.currentLang === "en" ? "Norway" : "Norvège",
				om: mcubeArgs.currentLang === "en" ? "Oman" : "Oman",
				pk: mcubeArgs.currentLang === "en" ? "Pakistan" : "Pakistan",
				pw: mcubeArgs.currentLang === "en" ? "Palau" : "Palaos",
				ps: mcubeArgs.currentLang === "en" ? "Palestine" : "Palestine",
				pa: mcubeArgs.currentLang === "en" ? "Panama" : "Panama",
				pg: mcubeArgs.currentLang === "en" ? "Papua New Guinea" : "Papouasie Nouvelle Guinée",
				py: mcubeArgs.currentLang === "en" ? "Paraguay" : "Paraguay",
				pe: mcubeArgs.currentLang === "en" ? "Peru" : "Perou",
				ph: mcubeArgs.currentLang === "en" ? "Philippines" : "Philippines",
				pl: mcubeArgs.currentLang === "en" ? "Poland" : "Pologne",
				pt: mcubeArgs.currentLang === "en" ? "Portugal" : "Portugal",
				pr: mcubeArgs.currentLang === "en" ? "Puerto Rico" : "Porto Rico",
				qa: mcubeArgs.currentLang === "en" ? "Qatar" : "Qatar",
				re: mcubeArgs.currentLang === "en" ? "Réunion" : "Réunion",
				ro: mcubeArgs.currentLang === "en" ? "Romania" : "Romanie",
				ru: mcubeArgs.currentLang === "en" ? "Russia" : "Russie",
				rw: mcubeArgs.currentLang === "en" ? "Rwanda" : "Rwanda",
				ws: mcubeArgs.currentLang === "en" ? "Samoa" : "Samoa",
				sm: mcubeArgs.currentLang === "en" ? "San Marino" : "Saint Marin",
				st: mcubeArgs.currentLang === "en" ? "São Tomé & Príncipe" : "Sao Tomé-et-Principe",
				sa: mcubeArgs.currentLang === "en" ? "Saudi Arabia" : "Arabie saoudite",
				sn: mcubeArgs.currentLang === "en" ? "Senegal" : "Sénégal",
				rs: mcubeArgs.currentLang === "en" ? "Serbia" : "Serbie",
				sc: mcubeArgs.currentLang === "en" ? "Seychelles" : "Seychelles",
				sl: mcubeArgs.currentLang === "en" ? "Sierra Leone" : "Sierra Leone",
				sg: mcubeArgs.currentLang === "en" ? "Singapore" : "Singapore",
				sx: mcubeArgs.currentLang === "en" ? "Sint Maarten" : "Saint-Martin",
				sk: mcubeArgs.currentLang === "en" ? "Slovakia" : "Slovaquie",
				si: mcubeArgs.currentLang === "en" ? "Slovenia" : "Slovénie",
				sb: mcubeArgs.currentLang === "en" ? "Solomon Islands" : "îles Salomon",
				so: mcubeArgs.currentLang === "en" ? "Somalia" : "Somalie",
				za: mcubeArgs.currentLang === "en" ? "South Africa" : "Afrique du Sud",
				kr: mcubeArgs.currentLang === "en" ? "South Korea" : "Corée du Sud",
				ss: mcubeArgs.currentLang === "en" ? "South Sudan" : "Soudan du Sud",
				es: mcubeArgs.currentLang === "en" ? "Spain" : "Espagne",
				lk: mcubeArgs.currentLang === "en" ? "Sri Lanka" : "Sri Lanka",
				bl: mcubeArgs.currentLang === "en" ? "St Barthélemy" : "St Barthélemy",
				sh: mcubeArgs.currentLang === "en" ? "St Helena" : "Sainte-Hélène",
				kn: mcubeArgs.currentLang === "en" ? "St Kitts & Nevis" : "Saint-Kitts-et-Nevis",
				lc: mcubeArgs.currentLang === "en" ? "St Lucia" : "Sainte Lucie",
				mf: mcubeArgs.currentLang === "en" ? "St Martin" : "Saint-Martin",
				pm: mcubeArgs.currentLang === "en" ? "St Pierre & Miquelon" : "Saint-Pierre-et-Miquelon",
				vc: mcubeArgs.currentLang === "en" ? "St Vincent & Grenadines" : "Saint-Vincent-et-les Grenadines",
				sd: mcubeArgs.currentLang === "en" ? "Sudan" : "Soudan",
				sr: mcubeArgs.currentLang === "en" ? "Suriname" : "Suriname",
				sj: mcubeArgs.currentLang === "en" ? "Svalbard & Jan Mayen" : "Svalbard et Jan Mayen",
				se: mcubeArgs.currentLang === "en" ? "Sweden" : "Suède",
				ch: mcubeArgs.currentLang === "en" ? "Switzerland" : "Suisse",
				sy: mcubeArgs.currentLang === "en" ? "Syria" : "Syrie",
				tw: mcubeArgs.currentLang === "en" ? "Taiwan" : "Taiwan",
				tj: mcubeArgs.currentLang === "en" ? "Tajikistan" : "Tadjikistan",
				tz: mcubeArgs.currentLang === "en" ? "Tanzania" : "Tanzanie",
				th: mcubeArgs.currentLang === "en" ? "Thailand" : "Thailande",
				tl: mcubeArgs.currentLang === "en" ? "Timor-Leste" : "Timor-Leste",
				tg: mcubeArgs.currentLang === "en" ? "Togo" : "Togo",
				tk: mcubeArgs.currentLang === "en" ? "Tokelau" : "Tokelau",
				to: mcubeArgs.currentLang === "en" ? "Tonga" : "Tonga",
				tt: mcubeArgs.currentLang === "en" ? "Trinidad & Tobago" : "Trinité-et-Tobago",
				tn: mcubeArgs.currentLang === "en" ? "Tunisia" : "Tunisie",
				tr: mcubeArgs.currentLang === "en" ? "Turkey" : "Turquie",
				tm: mcubeArgs.currentLang === "en" ? "Turkmenistan" : "Turkménistan",
				tc: mcubeArgs.currentLang === "en" ? "Turks & Caicos Islands" : "Îles Turks et Caïques",
				tv: mcubeArgs.currentLang === "en" ? "Tuvalu" : "Tuvalu",
				ug: mcubeArgs.currentLang === "en" ? "Uganda" : "Ouganda",
				ua: mcubeArgs.currentLang === "en" ? "Ukraine" : "Ukraine",
				ae: mcubeArgs.currentLang === "en" ? "United Arab Emirates" : "Émirats Arabes Unis",
				gb: mcubeArgs.currentLang === "en" ? "United Kingdom" : "Royaume-Uni",
				us: mcubeArgs.currentLang === "en" ? "United States" : "États‑Unis",
				uy: mcubeArgs.currentLang === "en" ? "Uruguay" : "Uruguay",
				vi: mcubeArgs.currentLang === "en" ? "US Virgin Islands" : "Îles Vierges américaines",
				uz: mcubeArgs.currentLang === "en" ? "Uzbekistan" : "Ouzbékistan",
				vu: mcubeArgs.currentLang === "en" ? "Vanuatu" : "Vanuatu",
				va: mcubeArgs.currentLang === "en" ? "Vatican City" : "Vatican",
				ve: mcubeArgs.currentLang === "en" ? "Venezuela" : "Venezuela",
				vn: mcubeArgs.currentLang === "en" ? "Vietnam" : "Vietnam",
				wf: mcubeArgs.currentLang === "en" ? "Wallis & Futuna" : "Wallis et Futuna",
				eh: mcubeArgs.currentLang === "en" ? "Western Sahara" : "Sahara occidental",
				ye: mcubeArgs.currentLang === "en" ? "Yemen" : "Yemen",
				zm: mcubeArgs.currentLang === "en" ? "Zambia" : "Zambie",
				zw: mcubeArgs.currentLang === "en" ? "Zimbabwe" : "Zimbabwe",
				ax: mcubeArgs.currentLang === "en" ? "Åland Islands" : "Åland"
			}
		});

		telInputEl.addEventListener("focusout", () => {
			// const isValid = telInputEl.iti.isValidNumber();
			const value = telInputEl.value.trim().split(' ').join('');
			const formattedNumber = telInputEl.iti.getNumber();
			telInputEl.iti.hiddenInput.value = formattedNumber;
		});
	});
}


